module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_sekundaerlogo_postale_troendelag_pos.21a1a847.png";